<template>
	<component :is='c_tag' :md1="md==1" :md3="md==3" :md4="md==4" :md8="md==8">
		<fs1-span><b>{{label || ''}}</b></fs1-span>
		<fs1-tooltip v-if="tooltip" :text="tooltip"/>
		<slot></slot>
		<v-switch class="ma-0" :input-value="text" :disabled="disabled" v-on:change="updateInput"/>
		<value-container v-if="old_value != undefined" :value="old_value?'Sí':'No'" class_name="output_old_value_edit"/>
	</component>
</template>

<script>
import inputs from '../mixins/inputs/inputs.js';
export default {
	mixins:[inputs],
  model: { prop: "text", event: "input" },
	props: ['text','on_change'],
  methods: { updateInput(v) { this.dev_log({v}); this.$emit('input', v);this.on_change && this.on_change() } }
};
</script>
